export var System;
(function (System) {
    System["Primary"] = "#419BF9";
    System["Dark"] = "#0D7FFF";
    System["Light"] = "#C1E0FF";
    System["Lightest"] = "#E2F0FF";
    System["Success"] = "#35ED98";
})(System || (System = {}));
export var Neutrals;
(function (Neutrals) {
    Neutrals["Dark"] = "#333333";
    Neutrals["Text"] = "#6F747C";
    Neutrals["Gray"] = "#8c8c8c";
    Neutrals["Border"] = "#D1D3D6";
    Neutrals["Light"] = "#F2F4F8";
    Neutrals["Paper"] = "#FFFFFF";
})(Neutrals || (Neutrals = {}));
export var NeutralsFixed;
(function (NeutralsFixed) {
    NeutralsFixed["Dark"] = "#131821";
    NeutralsFixed["Text"] = "#6F747C";
    NeutralsFixed["Border"] = "#D1D3D6";
    NeutralsFixed["Light"] = "#F2F4F8";
    NeutralsFixed["Gray"] = "#8c8c8c";
    NeutralsFixed["Paper"] = "#FFFFFF";
})(NeutralsFixed || (NeutralsFixed = {}));
export var Feedback;
(function (Feedback) {
    Feedback["Alert"] = "#FF6565";
    Feedback["AlertLight"] = "#FFE0E0";
    Feedback["Success"] = "#1ECAA1";
    Feedback["SuccessLight"] = "#DCFFF0";
    Feedback["Warning"] = "#FFCB5C";
    Feedback["WarningLight"] = "#FFECC2";
    Feedback["Info"] = "#0038FF";
    Feedback["InfoLight"] = "#E0E7FF";
    Feedback["InfoSpecial"] = "#E0E7FF";
})(Feedback || (Feedback = {}));
export var Brand;
(function (Brand) {
    Brand["Primary"] = "#6659E3";
    Brand["Dark"] = "#4636DD";
    Brand["Light"] = "#DAD7F8";
    Brand["Lightest"] = "#F0EEFC";
    Brand["Special"] = "#56CF7D";
    Brand["SpecialDark"] = "#47AB67";
})(Brand || (Brand = {}));
export var Overlay;
(function (Overlay) {
    Overlay["Light"] = "rgba(19, 24, 33, 0.16)";
    Overlay["Default"] = "rgba(19, 24, 33, 0.6)";
    Overlay["Hover"] = "rgba(19, 24, 33, 0.85)";
})(Overlay || (Overlay = {}));
export var OverlayFixed;
(function (OverlayFixed) {
    OverlayFixed["Light"] = "rgba(19, 24, 33, 0.16)";
    OverlayFixed["Default"] = "rgba(19, 24, 33, 0.6)";
    OverlayFixed["Hover"] = "rgba(19, 24, 33, 0.85)";
})(OverlayFixed || (OverlayFixed = {}));
export var Pro;
(function (Pro) {
    Pro["Badge"] = "#F4C304";
})(Pro || (Pro = {}));
//# sourceMappingURL=Color.js.map